export default __webpack_public_path__ + "static/Idea@2x-ad87a81f81930dc493387a25e3cf8ac2.webp";